import * as Yup from 'yup';

export const slugSchema = Yup
  .string()
  .optional()
  .matches(
    /^([a-z]+)$/,
    'Слаг повинен містити тільки символи латинського алфавіту',
  )
  .length(6, ({ length }) => `Слаг повинен складатися рівно з ${length} символів`);
